import React from 'react';
import ExpenseForm from '../components/ExpenseForm';

const EmployeeExpenseForm = () => {
  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h1 className="page-title">Expense Submission</h1>
          <p className="page-subtitle">Submit a new expense with supporting proof</p>
        </div>
      </div>

      <div className="card" style={{ maxWidth: '800px' }}>
        <div className="card-body">
          <ExpenseForm />
        </div>
      </div>
    </div>
  );
};

export default EmployeeExpenseForm;
